import { render } from "./BottomClaim.vue?vue&type=template&id=3ceebe4a&scoped=true"
import script from "./BottomClaim.vue?vue&type=script&lang=js"
export * from "./BottomClaim.vue?vue&type=script&lang=js"

import "./BottomClaim.vue?vue&type=style&index=0&id=3ceebe4a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ceebe4a"]])

export default __exports__